import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PageSkeleton } from '@/components/ui/page-skeleton';

const importacionesSearchSchema = z.object({
  lote: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/admin/recet/importaciones')({
  validateSearch: importacionesSearchSchema,
  pendingComponent: PageSkeleton,
});
